import Box from "@cloudscape-design/components/box"

// TODO(#60): Point this at the final CDR logo asset (e.g. "/cdr-logo.svg" in public/).
// While null, only the text branding renders.
const LOGO_SRC: string | null = null

const CdrLogo = () => (
  <Box textAlign="center">
    {LOGO_SRC && (
      <div className="cdr-logo-placeholder">
        <img src={LOGO_SRC} alt="CDR logo" width="64" height="64" />
      </div>
    )}
    <Box variant="h1" margin={{ top: "s" }}>
      CDR
    </Box>
  </Box>
)

export default CdrLogo
